import '../node_modules/bootstrap/scss/bootstrap.scss' 
import React, { useState, useEffect, useRef } from 'react';
import QRCode from 'qrcode'
import Viewer, { Worker } from '@phuocng/react-pdf-viewer';
import '@phuocng/react-pdf-viewer/cjs/react-pdf-viewer.css';
import Carousel from 'react-bootstrap/Carousel';
import Velocity from 'velocity-animate';


// import logo from './logo.svg';
import bg from './img/bg.png';
import productos from './img/productos.gif'
import digital from './img/digital.gif'
import './App.css';

import Breadcrumbs from './Breadcrumbs'
import Nav from './Nav'

import { Link } from "react-router-dom";


import cantorodado from './img/productos/cantorodado.png'

//
import c1 from './carousel/artepoliscantorodado/1.jpg'
import c2 from './carousel/artepoliscantorodado/2.jpg'
import c3 from './carousel/artepoliscantorodado/3.jpg'
import c4 from './carousel/artepoliscantorodado/4.jpg'
// import c5 from './carousel/fullcolor/5.jpg'
// import c6 from './carousel/fullcolor/6.jpg'
// import c7 from './carousel/fullcolor/7.jpg'
// import c8 from './carousel/fullcolor/8.jpg'
// import c9 from './carousel/fullcolor/9.jpg'
// import c10 from './carousel/fullcolor/10.jpg'



//
import pdfFileLocal from './fichas/Ficha Canto Rodado 2024.pdf'

function App() {

  let pdfFile = 'https://expo-melon.s3.amazonaws.com/fichas/Ficha Canto Rodado 2024.pdf'
  pdfFile = encodeURI(pdfFile);

  const slider1 = useRef();

  const [index, setIndex] = useState(0);

  let carousel = [
    c1,
    c2,
    c3,
    c4,
    // c5,
    // c6,
    // c7,
    // c8,
    // c9,
    // c10,  
  ]  

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };  

  let [showQRModal, setShowQRModal] = useState(false);
  let [showPDFModal, setShowPDFModal] = useState(false);

  useEffect(() => {
    document.querySelector('.slider1-slides').innerHTML = parseInt(slider1.current.attributes['data-slides'].value);
    document.querySelector('.slider1-index').innerHTML = 1;
  }, [])

  useEffect(() => {

    if (document.getElementById('qr-canvas')) {
      QRCode.toCanvas(document.getElementById('qr-canvas'), pdfFile, {width: 600}, function (error) {
        if (error) console.error(error)
      });      
    }



  }, [showQRModal])

  const slideLeft = (slider) => {

    let index = parseInt(slider.current.attributes['data-index'].value);
    let slides = parseInt(slider.current.attributes['data-slides'].value);    

    if (index > 0) {
      Velocity(slider.current, {translateX: '+=100%'}, {duration: 250, complete: () => slider.current.setAttribute('data-index', index-1)});
      document.querySelector('.slider1-index').innerHTML = index;
    } else if (index==0) {
      // Velocity(slider.current, {translateX: '0%'}, {duration: 250, complete: () => slider.current.setAttribute('data-index', 0)});
    } 

  }

  const slideRight = (slider) => {

    let index = parseInt(slider.current.attributes['data-index'].value);
    let slides = parseInt(slider.current.attributes['data-slides'].value);

    if (index < slides-1) {
      Velocity(slider.current, {translateX: '-=100%'}, {duration: 250, complete: () => slider.current.setAttribute('data-index', index+1)});
      document.querySelector('.slider1-index').innerHTML = index+2;
      
    } else if (index==slides-1) {
      Velocity(slider.current, {translateX: '0%'}, {duration: 250, complete: () => slider.current.setAttribute('data-index', 0)});
      document.querySelector('.slider1-index').innerHTML = 1;
      
    }

  }


  return (
    <div className="App container-fluid g-0 fullvh">


    {showQRModal &&

      <div className="modal-container d-flex flex-column" onClick={() => setShowQRModal(false)}>
          <button style={{position: 'absolute', top: '5vh', left: '66vw', zIndex: 9}} className="nav-button" onClick={() => setShowQRModal(false)}><i className="fa-sharp fa-solid fa-close" data-fa-mask="fa-solid fa-comment"></i></button>
          <div className="modal-content d-flex flex-1 align-items-center justify-center">
            <div className="row">
              <div className="col">
                <div className="bg-white p-3">
                  <canvas id="qr-canvas" width="400" height="400"></canvas>                  
                </div>
              </div>
            </div>
          </div>
      </div>

    }

    {showPDFModal &&

      <div className="modal-container d-flex flex-column">
        <button style={{position: 'absolute', top: '0vh', left: '76.5vw', zIndex: 9}} className="nav-button" onClick={() => setShowPDFModal(false)}><i className="fa-sharp fa-solid fa-close" data-fa-mask="fa-solid fa-comment"></i></button>
        <div className="modal-content d-flex flex-1 align-items-center justify-center">
          <div className="row">
            <div className="col">
              <div className="bg-white p-3">
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.4.456/build/pdf.worker.min.js">
                    <div style={{ height: '100vh', width: '50vw' }}>
                        <Viewer fileUrl={pdfFileLocal} />
                    </div>
                </Worker>
              </div>
            </div>
          </div>
        </div>
      </div>

    }    

      <div className="row g-0">

        <img src={productos} className="bg" />

        <div className="row g-0 fullvh">

          {/*<Breadcrumbs />*/}

          <div className="col-1 g-0">
            <Nav />
          </div>

          <div className=" col-11 d-flex">

            <div className="row g-0 d-flex flex-1 flex-column justify-center">

              <div className="col d-flex flex-column justify-center">

                <div className="row inner-board ps-5 pt-5 pb-5">

                  <Breadcrumbs />
                  
                  <div className="d-flex flex-row pb-3">
                    <img className="producto-logo-2x"  src={cantorodado} />
                    <div className="d-flex flex-column justify-center">
                      <h3 className="t-54 ps-3">Artépolis Canto Rodado</h3>
                    </div>
                    
                  </div>

                  <div className="col">

                    <div className="row">
                      <div className="col-6 d-flex flex-column">


                        <div className="product-left overflow-hidden d-flex flex-1">

                          <div ref={slider1} data-index="0" data-slides="2" className="product-left-slider d-flex flex-row align-items-center">
                           
                             <div className="product-left-slider-slide d-flex align-items-center justify-center">
                              
                              <div className="inner-description">


<p>También conocido como hormigón desactivado o árido visto, es un <b>pavimento que expone el agregado superficial mediante un proceso de lavado</b>. Aprovecha las características naturales de los áridos empleados para ofrecer texturas variadas y alta durabilidad con textura antideslizante, ideal para entornos exteriores.</p>


<p>Producto compatible con Fullcolor®.</p>

                              </div>

                            </div>

                           

                          </div>

                        </div>
                        <div className="product-left-pagination d-flex flex-row space-between d-none">
                          <button className="inner-button" onClick={() => slideLeft(slider1)}><span><span className="chevron">&lt;</span></span></button>
                          <p ><span className="slider1-index"></span>/<span className="slider1-slides"></span></p>
                          <button className="inner-button" onClick={() => slideRight(slider1)}><span><span className="chevron">></span></span></button>
                        </div>

                      </div>
                      <div className="col-6 pe-6">
                        <div className="row d-flex flex-column">
                          <div className="col overflow-hidden">
                            <div className="product-carousel">                            
                              <Carousel variant="dark">                              
{/*                                <Carousel.Item>
                                  <iframe width="780" height="515" src="https://www.youtube.com/embed/hO1JUZs1xGQ" title="COPPERMIX MELON" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>
                                </Carousel.Item>*/}
                                {carousel.map((imgsrc, index) => (
                                  <Carousel.Item key={index}>
                                    <img
                                      className="d-block w-100"
                                      src={imgsrc}
                                    />
                                  </Carousel.Item>
                                    )
                                )}
                              </Carousel>
                            </div>


                          </div>
                          <div className="col space-between d-flex pt-5">
                            
                            <button className="inner-button" onClick={() => setShowPDFModal(true)}><span>Ver ficha <span className="chevron">></span></span></button>

                            <button className="inner-button" onClick={() => setShowQRModal(true)}><span>Descargar ficha <span className="chevron">></span></span></button>


                          </div>
                        </div>
                        
                      </div>                      
                    </div>


                  </div>
                </div>
                
              </div>
              
            </div>
            
          </div>          
          
        </div>

      </div>

    </div>
  );
}

export default App;
